var _defs, _rect, _ellipse, _ellipse2, _g, _g2, _g3, _path, _path2, _g4, _g5, _ellipse3, _ellipse4, _line, _ellipse5, _g6, _g7, _g8, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveBroadcast(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1600 900",
    preserveAspectRatio: "xMidYMid slice",
    role: "img",
    "aria-label": "Estadio iluminado preparado para una retransmisi\\xF3n deportiva en directo",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lb-sky",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0c0a09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#1f1410"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3a1f10"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "lb-spot",
    cx: "50%",
    cy: "0%",
    r: "60%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fcd34d",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopColor: "#f59e0b",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#000000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lb-stadium",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3f2412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1a0f08"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lb-grass",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3b2918"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#150d07"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "lb-wave",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fcd34d",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#fcd34d",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fcd34d",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    fill: "url(#lb-sky)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 400,
    cy: 0,
    rx: 520,
    ry: 520,
    fill: "url(#lb-spot)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1200,
    cy: 0,
    rx: 520,
    ry: 520,
    fill: "url(#lb-spot)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3a2616",
    stroke: "#8b6a3a",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 90,
    width: 14,
    height: 320,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1366,
    y: 90,
    width: 14,
    height: 320,
    rx: 3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#1c1108",
    stroke: "#a47d3f",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 60,
    width: 120,
    height: 60,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1316,
    y: 60,
    width: 120,
    height: 60,
    rx: 6
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#fde68a"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 195,
    cy: 90,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 90,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 90,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1341,
    cy: 90,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1376,
    cy: 90,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1411,
    cy: 90,
    r: 8
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,640 C200,560 360,540 540,548 C720,556 880,540 1060,540 C1240,540 1400,560 1600,640 L1600,900 L0,900 Z",
    fill: "url(#lb-stadium)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,640 C200,560 360,540 540,548 C720,556 880,540 1060,540 C1240,540 1400,560 1600,640",
    fill: "none",
    stroke: "#d4a24f",
    strokeOpacity: 0.45,
    strokeWidth: 2
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeOpacity: 0.35,
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,680 C300,615 540,600 800,602 C1060,604 1300,615 1560,680"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,725 C300,665 540,650 800,652 C1060,654 1300,665 1560,725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,770 C300,715 540,700 800,702 C1060,704 1300,715 1560,770"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#a47d3f",
    fillOpacity: 0.55
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 640,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 635,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 632,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 625,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430,
    cy: 618,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 520,
    cy: 612,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 640,
    cy: 608,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 760,
    cy: 606,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 880,
    cy: 606,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1000,
    cy: 608,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1120,
    cy: 612,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1240,
    cy: 618,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1340,
    cy: 628,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1410,
    cy: 636,
    r: 3
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 800,
    cy: 780,
    rx: 620,
    ry: 120,
    fill: "url(#lb-grass)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 800,
    cy: 780,
    rx: 620,
    ry: 120,
    fill: "none",
    stroke: "#d4a24f",
    strokeOpacity: 0.35,
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 660,
    x2: 800,
    y2: 900,
    stroke: "#d4a24f",
    strokeOpacity: 0.25,
    strokeWidth: 2
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 800,
    cy: 780,
    rx: 80,
    ry: 18,
    fill: "none",
    stroke: "#d4a24f",
    strokeOpacity: 0.35,
    strokeWidth: 2
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(800,380)",
    fill: "none",
    stroke: "#fcd34d",
    strokeOpacity: 0.55,
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -180,0 a180,90 0 0 1 360,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -120,0 a120,60 0 0 1 240,0",
    strokeOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -60,0 a60,30 0 0 1 120,0",
    strokeOpacity: 0.9
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(720,300)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 100,
    x2: 40,
    y2: 240,
    stroke: "#a47d3f",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 100,
    x2: 120,
    y2: 240,
    stroke: "#a47d3f",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 100,
    x2: 80,
    y2: 240,
    stroke: "#a47d3f",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 60,
    width: 120,
    height: 60,
    rx: 8,
    fill: "#1a1109",
    stroke: "#d4a24f",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 90,
    r: 22,
    fill: "#0c0907",
    stroke: "#d4a24f",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 90,
    r: 10,
    fill: "#3a1f10"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174,
    cy: 86,
    r: 3,
    fill: "#fde68a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 40,
    width: 50,
    height: 22,
    rx: 3,
    fill: "#1a1109",
    stroke: "#d4a24f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 90,
    r: 5,
    fill: "#ef4444"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    values: "1;0.3;1",
    dur: "1.6s",
    repeatCount: "indefinite"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(110,140)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 160,
    height: 44,
    rx: 22,
    fill: "#ef4444"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 22,
    r: 9,
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.25;1",
    dur: "1.4s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    x: 46,
    y: 30,
    fill: "#ffffff",
    fontFamily: "Inter, Helvetica, Arial, sans-serif",
    fontSize: 22,
    fontWeight: 800,
    letterSpacing: 3
  }, "LIVE"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 540,
    width: 1600,
    height: 360,
    fill: "url(#lb-grass)",
    opacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveBroadcast);
export default __webpack_public_path__ + "static/media/live-broadcast.b10dac347c1f478db4143c0813f9c40f.svg";
export { ForwardRef as ReactComponent };